import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Edit, Undo } from '@mui/icons-material';
import { InputAdornment, TextField, Tooltip } from '@mui/material';
import { useUpdateApplicationManagementMutation } from 'reduxState/store/applicationManagement/api';
import { ConfirmEdit } from './ConfirmEdit';
import { ApplicationManagement } from '../../../reduxState/store/applicationManagement/types';
import '../scss/ProductPageUrl.scss';

export interface Props {
  applicationId: string;
  applicationManagement: ApplicationManagement;
}

export const ProductPageUrl = ({ applicationId, applicationManagement }: Props) => {
  const { user } = useAuth0();

  const [isDisabled, setDisabled] = useState(true);
  const [value, setValue] = useState(applicationManagement.ProductPageURL);
  const [updateApplicationManagement] = useUpdateApplicationManagementMutation();

  const cancelEdit = () => {
    setValue(applicationManagement.ProductPageURL);
    setDisabled(true);
  };

  const handleSave = () => {
    updateApplicationManagement({
      appId: applicationId,
      applicationManagement: { ...applicationManagement, ProductPageURL: value },
      author: user?.email ?? 'missing email',
    });
    setDisabled(true);
  };

  return (
    <div className="product-page-url settings-form-group ">
      <TextField
        id="productPageUrl"
        className={`product-page-url-input ${!isDisabled ? 'user-editing' : ''}`}
        label="Product Page URL"
        value={value}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        inputRef={input => input && !isDisabled && input.focus()}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              {!isDisabled ? (
                <Tooltip title="Cancel editing" role="tooltip">
                  <Undo onClick={cancelEdit} className="edit-icon-undo" data-testid="undo-button" />
                </Tooltip>
              ) : (
                <Edit onClick={() => setDisabled(d => !d)} className="edit-icon" data-testid="edit-button" />
              )}
            </InputAdornment>
          ),
        }}
        onChange={e => setValue(e.target.value)}
        disabled={isDisabled}
      />
      {!isDisabled && (
        <ConfirmEdit
          headerText={'Edit Product Page URL'}
          confirmText={`Confirm update to product page url:`}
          changeText={value}
          onSave={handleSave}
        />
      )}
    </div>
  );
};
